import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "services",
    defaultRoutePath: "/cars/service",
    menuItemScope: "fleet",
    menuItemName: "services",

    routes: [
        {
            path: "/cars/service",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },

        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "editpin",
            Component: Wizards.EditPin,
        },
        {
            path: "editstoragelocation",
            Component: Wizards.EditStorageLocation,
        },
        {
            path: "genericFileAssociation",
            Component: Wizards.GenericFileAssociation,
        },
    ],

}

export default Module;
